import { getLocale, SupportedLocale } from '@tlx/intl';
import en from '@Locale/en.json';
import no from '@Locale/no.json';

export type LocaleKey = keyof typeof no;
export const messages: Record<string, Record<LocaleKey, string>> = { en, no };
// Allows us to get type safe access to the current locale from useIntl
declare global {
    // eslint-disable-next-line @typescript-eslint/no-namespace
    namespace FormatjsIntl {
        interface IntlConfig {
            locale: SupportedLocale;
        }

        interface Message {
            ids: LocaleKey;
        }
    }
}
export type UseIntlMessagesReturn = Record<string, string> | undefined;

export function useIntlMessages(locale: SupportedLocale): UseIntlMessagesReturn {
    return locale === 'en' ? messages['en'] : messages['no'];
}

export function getMessage(key: LocaleKey, params?: Record<string, string>): string {
    const currentLocale = getLocale();
    return getLocalizedMessage(currentLocale, key, params);
}

export function getLocaleMessage(locale: SupportedLocale, key: LocaleKey, params?: Record<string, string>): string {
    return getLocalizedMessage(locale, key, params);
}

function getLocalizedMessage(locale: SupportedLocale, key: LocaleKey, params?: Record<string, string>) {
    const language = locale === 'en' ? en : no; // default to norwegian
    let translatedText = language[key] ?? key;

    if (params !== undefined) {
        const paramKeys = Object.keys(params);
        for (const key of paramKeys) {
            translatedText = translatedText.replaceAll(`{${key}}`, params[key]);
        }
    }

    return translatedText;
}

export type MonthTextKey = Extract<LocaleKey, `month_${string}`>;

export const capitalizedMonthKeys: Record<number, MonthTextKey> = {
    0: 'month_first_upper_1',
    1: 'month_first_upper_2',
    2: 'month_first_upper_3',
    3: 'month_first_upper_4',
    4: 'month_first_upper_5',
    5: 'month_first_upper_6',
    6: 'month_first_upper_7',
    7: 'month_first_upper_8',
    8: 'month_first_upper_9',
    9: 'month_first_upper_10',
    10: 'month_first_upper_11',
    11: 'month_first_upper_12',
};
